export default {
  completed: {
    id: 'bo_sellers_customer_care_table_column_status_completed',
    defaultMessage: 'Completed',
  },
  processing: {
    id: 'bo_sellers_customer_care_status_processing',
    defaultMessage: 'Processing',
  },
}
